const data = {
  Wholedata: [
    {
      id: "company",
      name: "Company",
      data: [
        {
          id: "company",
          name: "Overall company OKRs",
          data: [
            {
              name: "Top Company Objectives",
              id: 1,
              chunk: [
                {
                  heading: "Overall Company Goals",
                  headingData: [
                    {
                      objective: "Research and improve customer satisfaction",
                      keyResult: [
                        {
                          id: 9,
                          data: "Exceed Net Promoter Score (NPS) of over 8.0",
                          min: "0",
                          max: "9",
                          data_name: "5",
                          data_type: "",
                        },
                        {
                          id: 10,
                          data:
                            "Get 1000 survey responses to annual satisfaction survey",
                          min: "0",
                          max: "1000",
                          data_name: "700",
                          data_type: "%",
                        },
                        {
                          id: 11,
                          data:
                            "Conduct 50 phone interviews with top customers",
                          min: "0",
                          max: "50",
                          data_name: "40",
                          data_type: "",
                        },
                        {
                          id: 12,
                          data:
                            "Conduct 15 phone interviews with recently churned customers",
                          min: "0",
                          max: "15",
                          data_name: "5",
                          data_type: "",
                        },
                        {
                          id: 12,
                          data:
                            "Present an action plan of 10 improvements for next quarter",
                          min: "0",
                          max: "10",
                          data_name: "4",
                          data_type: "",
                        },
                      ],
                    },
                    {
                      objective:
                        "Achieve record revenues while increasing profitability",
                      keyResult: [
                        {
                          id: 13,
                          data: "Hit quarterly revenue of over $1000000",
                          min: "0",
                          max: "1000000",
                          data_name: "1000000",
                          data_type: "$",
                        },
                        {
                          id: 14,
                          data:
                            "Start sales in 2 new countries and achieve first quarter revenues totaling over $100000",
                          min: "0",
                          max: "100000",
                          data_name: "500000",
                          data_type: "$",
                        },
                        {
                          id: 15,
                          data:
                            "Increase gross profit margin % from 54% to 65%",
                          min: "0",
                          max: "65",
                          data_name: "60",
                          data_type: "%",
                        },
                      ],
                    },
                    {
                      objective: "Increase recurring revenues",
                      keyResult: [
                        {
                          id: 16,
                          data:
                            "Reach monthly recurring revenue ($ MRR) of $250000",
                          min: "0",
                          max: "250000",
                          data_name: "20000",
                          data_type: "$",
                        },
                        {
                          id: 17,
                          data:
                            "Increase the share of monthly subscriptions vs one-time contracts sold to 85%",
                          min: "0",
                          max: "85",
                          data_name: "80",
                          data_type: "%",
                        },
                        {
                          id: 18,
                          data:
                            "Increase average subscription size to at least $295 per month",
                          min: "0",
                          max: "300",
                          data_name: "260",
                          data_type: "$",
                        },
                        {
                          id: 19,
                          data: "Increase annual renewals to 75%",
                          min: "0",
                          max: "75",
                          data_name: "50",
                          data_type: "%",
                        },
                        {
                          id: 20,
                          data: "Reduce churn % to less than 1% monthly",
                          min: "0",
                          max: "10",
                          data_name: "2",
                          data_type: "%",
                        },
                      ],
                    },
                    {
                      objective: "Improve internal employee engagement",
                      keyResult: [
                        {
                          id: 21,
                          data:
                            "Conduct 3 monthly 'Fun Friday' all-hands meetings with motivational speakers",
                          min: "0",
                          max: "3",
                          data_name: "1",
                          data_type: "",
                        },
                        {
                          id: 22,
                          data:
                            "Interview 48 employees on their needs for improving our work culture.",
                          min: "0",
                          max: "50",
                          data_name: "30",
                          data_type: "",
                        },
                        {
                          id: 23,
                          data:
                            "Implement using OKRs and Mesh software in all of our 23 teams",
                          min: "0",
                          max: "23",
                          data_name: "20",
                          data_type: "",
                        },
                        {
                          id: 24,
                          data:
                            "Reach weekly employee satisfaction score of at least 4.7 points",
                          min: "0",
                          max: "5",
                          data_name: "3.9",
                          data_type: "",
                        },
                      ],
                    },
                    {
                      objective:
                        "Successfully launch version 3 of our main product",
                      keyResult: [
                        {
                          id: 25,
                          data: "Get over 10000 new signups",
                          min: "0",
                          max: "10000",
                          data_name: "850",
                          data_type: "",
                        },
                        {
                          id: 26,
                          data:
                            "Get published product reviews in over 15 publications",
                          min: "0",
                          max: "20",
                          data_name: "10",
                          data_type: "",
                        },
                        {
                          id: 27,
                          data: "Achieve sign-up to % trial ratio of over 25%",
                          min: "0",
                          max: "30",
                          data_name: "18",
                          data_type: "%",
                        },
                        {
                          id: 28,
                          data: "Achieve trial to % paid ratio of over 50%",
                          min: "0",
                          max: "60",
                          data_name: "30",
                          data_type: "%",
                        },
                      ],
                    },
                    {
                      objective:
                        "Research, analyze & understand what our users and non-users really think",
                      keyResult: [
                        {
                          id: 29,
                          data:
                            "Sales team to conduct 50 phone interviews with key accounts",
                          min: "0",
                          max: "50",
                          data_name: "39",
                          data_type: "",
                        },
                        {
                          id: 30,
                          data:
                            "Support team to conduct 50 phone interviews with churned accounts",
                          min: "0",
                          max: "50",
                          data_name: "45",
                          data_type: "",
                        },
                        {
                          id: 31,
                          data:
                            "Product management to interview 25 external team leaders (non-users)",
                          min: "0",
                          max: "25",
                          data_name: "15",
                          data_type: "",
                        },
                        {
                          id: 32,
                          data:
                            "Design team conduct 30 web-based user testing sessions on new and old users",
                          min: "0",
                          max: "30",
                          data_name: "22",
                          data_type: "",
                        },
                      ],
                    },
                    {
                      objective:
                        "Simplify & clarify our product, messaging, presentation of things we do",
                      keyResult: [
                        {
                          id: 33,
                          data:
                            "25 on-site user-testing sessions to understand key product misunderstandings",
                          min: "0",
                          max: "25",
                          data_name: "20",
                          data_type: "",
                        },
                        {
                          id: 34,
                          data:
                            "10 tests of our recent infographics and slide decks for customer understanding",
                          min: "0",
                          max: "10",
                          data_name: "8",
                          data_type: "",
                        },
                        {
                          id: 35,
                          data:
                            "Get 1000 answers to an online user survey sent to all last quarter's signups",
                          min: "0",
                          max: "1000",
                          data_name: "888",
                          data_type: "",
                        },
                        {
                          id: 36,
                          data:
                            "Conduct a team hackathon to create and publish full portfolio of product materials",
                          min: "0",
                          max: "1",
                          data_name: "0",
                          data_type: "",
                        },
                        {
                          id: 37,
                          data:
                            "Present an action plan for next quarter's messaging improvements",
                          min: "0",
                          max: "1",
                          data_name: "0.5",
                          data_type: "",
                        },
                      ],
                    },
                    {
                      objective:
                        "Finish raising new capital for our growth needs",
                      keyResult: [
                        {
                          id: 38,
                          data:
                            "E-mail and phone outreach to 100 VCs and seed funds",
                          min: "0",
                          max: "100",
                          data_name: "75",
                          data_type: "",
                        },
                        {
                          id: 39,
                          data:
                            "Get at least 30 second contact meetings or conference calls",
                          min: "0",
                          max: "40",
                          data_name: "22",
                          data_type: "",
                        },
                        {
                          id: 40,
                          data:
                            "Solicit at least 3 term sheets of our minimum required terms",
                          min: "0",
                          max: "5",
                          data_name: "2",
                          data_type: "",
                        },
                        {
                          id: 41,
                          data:
                            "Close an investment round with the minimum of $10 million pre-money",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                      ],
                    },
                    {
                      objective:
                        "Be excellent - improve to be the best in whatever we do",
                      keyResult: [
                        {
                          id: 42,
                          data:
                            "All 13 teams to have an internal brainstorm meeting: How can we improve where we're not the best",
                          min: "0",
                          max: "13",
                          data_name: "10",
                          data_type: "",
                        },
                        {
                          id: 43,
                          data:
                            "Benchmark everything related to product to 10 key competitors",
                          min: "0",
                          max: "10",
                          data_name: "8",
                          data_type: "",
                        },
                        {
                          id: 44,
                          data:
                            "Survey 100 customers on their thoughts where we need to be better",
                          min: "0",
                          max: "100",
                          data_name: "44",
                          data_type: "",
                        },
                        {
                          id: 45,
                          data:
                            "Create an action list of 10 company-wide improvement activities",
                          min: "0",
                          max: "1",
                          data_name: "0",
                          data_type: "",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: "technology",
      name: "Technology",
      data: [
        {
          id: "performance",
          name: "Performance",
          data: [
            {
              name: "Top Company Objectives",
              id: 1,
              chunk: [
                {
                  heading: "Overall Company Goals",
                  headingData: [
                    {
                      objective: "Build a high performing engineering team",
                      keyResult: [
                        {
                          id: 46,
                          data:
                            "Increase performance capacity by 25% (Task: Hire 5 new back-end developers)",
                          min: "0",
                          max: "5",
                          data_name: "2",
                          data_type: "",
                        },
                        {
                          id: 47,
                          data:
                            "Develop and document performance metrics for the engineering team",
                          min: "0",
                          max: "1",
                          data_name: "0",
                          data_type: "",
                        },
                        {
                          id: 48,
                          data:
                            "Attend 2 additional industry-recognized conferences over last quarter",
                          min: "0",
                          max: "2",
                          data_name: "1",
                          data_type: "",
                        },
                      ],
                    },
                    {
                      objective: "Improve quality of the development process",
                      keyResult: [
                        {
                          id: 49,
                          data:
                            "Implement a process to assess development tools being used",
                          min: "0",
                          max: "1",
                          data_name: "0",
                          data_type: "",
                        },
                        {
                          id: 50,
                          data:
                            "Reduce the number of customers reported bugs by 25%",
                          min: "0",
                          max: "50",
                          data_name: "40",
                          data_type: "%",
                        },
                        {
                          id: 51,
                          data:
                            "Increase mandatory educational development time to 1 week each quarter",
                          min: "0",
                          max: "3",
                          data_name: "1",
                          data_type: "",
                        },
                      ],
                    },
                    {
                      objective:
                        "Ensure that release is delivered on time with high quality",
                      keyResult: [
                        {
                          id: 52,
                          data:
                            "Have engineering team contribute 10 story points",
                          min: "0",
                          max: "10",
                          data_name: "3",
                          data_type: "",
                        },
                        {
                          id: 53,
                          data: "Complete data migration",
                          min: "0",
                          max: "5",
                          data_name: "2",
                          data_type: "",
                        },
                        {
                          id: 54,
                          data:
                            "Have engineering team contribute 40 code review points",
                          min: "0",
                          max: "40",
                          data_name: "24",
                          data_type: "",
                        },
                        {
                          id: 55,
                          data: "Add 4 automated front-end tests",
                          min: "0",
                          max: "4",
                          data_name: "2",
                          data_type: "",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: "security",
          name: "Security",
          data: [
            {
              name: "Top Company Objectives",
              id: 2,
              chunk: [
                {
                  heading: "Overall Company Goals",
                  headingData: [
                    {
                      objective: "Increase data security",
                      keyResult: [
                        {
                          id: 56,
                          data: "Reduce occurrences of data breach to zero",
                          min: "0",
                          max: "100",
                          data_name: "80",
                          data_type: "%",
                        },
                        {
                          id: 57,
                          data: "Increase data recovery rate to 100%",
                          min: "0",
                          max: "100",
                          data_name: "65",
                          data_type: "%",
                        },
                        {
                          id: 58,
                          data:
                            "50% decrease in data migration and backup time",
                          min: "50",
                          max: "100",
                          data_name: "90",
                          data_type: "%",
                        },
                      ],
                    },
                    {
                      objective: "Improve company security",
                      keyResult: [
                        {
                          id: 59,
                          data:
                            "100% attendance of security awareness staff training",
                          min: "0",
                          max: "100",
                          data_name: "99",
                          data_type: "%",
                        },
                        {
                          id: 60,
                          data:
                            "50% increase in security using new protocol for addressing product security issues",
                          min: "40",
                          max: "60",
                          data_name: "55",
                          data_type: "",
                        },
                        {
                          id: 61,
                          data:
                            "Implement a new antivirus system across company",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                      ],
                    },
                    {
                      objective:
                        "Review and improve our data security procedures",
                      keyResult: [
                        {
                          id: 62,
                          data:
                            "For learning, review security policies of 5 other companies",
                          min: "0",
                          max: "5",
                          data_name: "3",
                          data_type: "%",
                        },
                        {
                          id: 63,
                          data:
                            "Conduct external penetration testing using at least 2 different software packages",
                          min: "0",
                          max: "4",
                          data_name: "2",
                          data_type: "",
                        },
                        {
                          id: 64,
                          data:
                            "Document our backup policies and make sure they get implemented",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                        {
                          id: 65,
                          data: "Guarantee uptime and availability of 99.95%",
                          min: "0",
                          max: "99.95",
                          data_name: "89",
                          data_type: "%",
                        },
                      ],
                    },
                  ],
                },
                {
                  heading: "Online marketing goals",
                  headingData: [
                    {
                      objective: "Generate new bookings pipeline",
                      keyResult: [
                        {
                          id: 30,
                          data: "Generate inflow of $12M in pipeline",
                          min: "8",
                          max: "12",
                          data_name: "9",
                          data_type: "%",
                        },
                        {
                          id: 31,
                          data:
                            "Keep pipeline above 5x of quota to ensure a 20% Win Rate",
                          min: "8",
                          max: "12",
                          data_name: "9",
                          data_type: "%",
                        },
                        {
                          id: 32,
                          data: "Do 7 product demos per week",
                          min: "8",
                          max: "12",
                          data_name: "9",
                          data_type: "%",
                        },
                      ],
                    },
                    {
                      objective: "Generate new bookings pipeline",
                      keyResult: [
                        {
                          id: 33,
                          data: "Generate inflow of $12M in pipeline",
                          min: "8",
                          max: "12",
                          data_name: "9",
                          data_type: "%",
                        },
                        {
                          id: 34,
                          data:
                            "Keep pipeline above 5x of quota to ensure a 20% Win Rate",
                          min: "8",
                          max: "12",
                          data_name: "9",
                          data_type: "%",
                        },
                        {
                          id: 35,
                          data: "Do 7 product demos per week",
                          min: "8",
                          max: "12",
                          data_name: "9",
                          data_type: "%",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: "product",
          name: "Product",
          data: [
            {
              name: "Top Company Objectives",
              id: 2,
              chunk: [
                {
                  heading: "Overall Company Goals",
                  headingData: [
                    {
                      objective: "Improve quality of product releases",
                      keyResult: [
                        {
                          id: 27,
                          data:
                            "Reduce bugs found during development process by 20%",
                          min: "0",
                          max: "50",
                          data_name: "44",
                          data_type: "",
                        },
                        {
                          id: 27,
                          data: "Improve unit testing coverage from 50% to 70%",
                          min: "50",
                          max: "70",
                          data_name: "68",
                          data_type: "%",
                        },
                        {
                          id: 28,
                          data: "Increase sprint capacity from 85 to 100 SP",
                          min: "85",
                          max: "100",
                          data_name: "93",
                          data_type: "",
                        },
                        {
                          id: 29,
                          data:
                            "Individual developers contribute 20% more code reviews by the end of every sprint",
                          min: "0",
                          max: "50",
                          data_name: "40",
                          data_type: "%",
                        },
                      ],
                    },
                    {
                      objective: "Improve speed of feature releases",
                      keyResult: [
                        {
                          id: 27,
                          data:
                            "Increase length of QA testing phase before entering user testing phase by 2 weeks",
                          min: "0",
                          max: "4",
                          data_name: "1",
                          data_type: "W",
                        },
                        {
                          id: 28,
                          data:
                            "Reduce reported bugs by 50% a week prior to feature release",
                          min: "0",
                          max: "100",
                          data_name: "30",
                          data_type: "",
                        },
                        {
                          id: 29,
                          data:
                            "Decrease of reported issues during development process by 25%",
                          min: "0",
                          max: "50",
                          data_name: "25",
                          data_type: "%",
                        },
                      ],
                    },
                    {
                      objective:
                        "Successfully launch version 3 of our main product",
                      keyResult: [
                        {
                          id: 27,
                          data: "Get over 10000 new signups",
                          min: "1",
                          max: "1000",
                          data_name: "200",
                          data_type: "",
                        },
                        {
                          id: 27,
                          data:
                            "Get published product reviews in over 15 publications",
                          min: "0",
                          max: "50",
                          data_name: "10",
                          data_type: "%",
                        },
                        {
                          id: 28,
                          data: "Achieve sign-up to trial ratio of over 25%",
                          min: "0",
                          max: "50",
                          data_name: "33",
                          data_type: "",
                        },
                        {
                          id: 29,
                          data: "Achieve trial to paid ratio of over 50%",
                          min: "0",
                          max: "50",
                          data_name: "10",
                          data_type: "",
                        },
                      ],
                    },
                    {
                      objective:
                        "Research, analyze & understand what our users and non-users really think",
                      keyResult: [
                        {
                          id: 27,
                          data:
                            "Sales team to conduct 50 phone interviews with key accounts",
                          min: "0",
                          max: "50",
                          data_name: "13",
                          data_type: "",
                        },
                        {
                          id: 27,
                          data:
                            "Support team to conduct 50 phone interviews with churned accounts",
                          min: "0",
                          max: "50",
                          data_name: "10",
                          data_type: "",
                        },
                        {
                          id: 28,
                          data:
                            "Product management to interview 25 external team leaders (non-users)",
                          min: "0",
                          max: "25",
                          data_name: "10",
                          data_type: "",
                        },
                        {
                          id: 29,
                          data:
                            "Design team conduct 30 web-based user testing sessions on new and old users",
                          min: "0",
                          max: "30",
                          data_name: "27",
                          data_type: "",
                        },
                      ],
                    },
                    {
                      objective: "Activate user-testing of our product",
                      keyResult: [
                        {
                          id: 27,
                          data:
                            "Conduct at least 21 face to face user testing & interview sessions",
                          min: "0",
                          max: "25",
                          data_name: "7",
                          data_type: "",
                        },
                        {
                          id: 27,
                          data:
                            "Receive at least 15 video interviews from users",
                          min: "0",
                          max: "15",
                          data_name: "3",
                          data_type: "",
                        },
                      ],
                    },
                    {
                      objective:
                        "Implement new 360-degree product planning process",
                      keyResult: [
                        {
                          id: 27,
                          data:
                            "Document clear role division between sales, marketing, design and development",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                        {
                          id: 27,
                          data:
                            "Decide on and document the process of input methods to and from sales, marketing, design and development back into product management",
                          min: "0",
                          max: "1",
                          data_name: "0",
                          data_type: "",
                        },
                        {
                          id: 28,
                          data:
                            "Integrate user testing into all activities in product planning and design phase",
                          min: "0",
                          max: "100",
                          data_name: "80",
                          data_type: "%",
                        },
                        {
                          id: 29,
                          data:
                            "Integrate user testing into pre-launch testing phase",
                          min: "0",
                          max: "100",
                          data_name: "60",
                          data_type: "%",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: "frontend",
          name: "Front-end Developer",
          data: [
            {
              name: "Top Company Objectives",
              id: 2,
              chunk: [
                {
                  heading: "Overall Company Goals",
                  headingData: [
                    {
                      objective: "Improve front-end speed",
                      keyResult: [
                        {
                          id: 27,
                          data:
                            "Ship 10 additional story points over last quarter",
                          min: "0",
                          max: "10",
                          data_name: "5",
                          data_type: "",
                        },
                        {
                          id: 28,
                          data: "Reduce average lead time by half",
                          min: "0",
                          max: "100",
                          data_name: "50",
                          data_type: "%",
                        },
                        {
                          id: 29,
                          data: "Increase unit test coverage by 40%",
                          min: "0",
                          max: "80",
                          data_name: "60",
                          data_type: "",
                        },
                      ],
                    },
                    {
                      objective: "Contribute to product quality",
                      keyResult: [
                        {
                          id: 27,
                          data:
                            "Increase code review time by 20 minutes each day",
                          min: "20",
                          max: "40",
                          data_name: "30",
                          data_type: "Min",
                        },
                        {
                          id: 28,
                          data:
                            "Increase time spent on learning new languages to 1 week each quarter",
                          min: "30",
                          max: "60",
                          data_name: "40",
                          data_type: "Min",
                        },
                        {
                          id: 29,
                          data:
                            "Ship 2 additional new front-end features this quarter",
                          min: "0",
                          max: "2",
                          data_name: "1",
                          data_type: "",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: "backend",
          name: "Back-end Developer",
          data: [
            {
              name: "Top Company Objectives",
              id: 2,
              chunk: [
                {
                  heading: "Overall Company Goals",
                  headingData: [
                    {
                      objective: "Improve software application performance",
                      keyResult: [
                        {
                          id: 27,
                          data: "Reduce API response time to 4s",
                          min: "4",
                          max: "10",
                          data_name: "5",
                          data_type: "S",
                        },
                        {
                          id: 28,
                          data:
                            "Reduce average application response time to <450ms",
                          min: "420",
                          max: "700",
                          data_name: "520",
                          data_type: "MS",
                        },
                        {
                          id: 29,
                          data: "Decrease code review times by half",
                          min: "0",
                          max: "100",
                          data_name: "40",
                          data_type: "%",
                        },
                      ],
                    },
                    {
                      objective: "Hire top backend talent",
                      keyResult: [
                        {
                          id: 27,
                          data:
                            "Attend 2 additional technology meetups over last quarter",
                          min: "0",
                          max: "2",
                          data_name: "1",
                          data_type: "",
                        },
                        {
                          id: 28,
                          data:
                            "Improve the recruiting process with new screening processes",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: "finance",
      name: "Finance & Accounting",
      data: [
        {
          id: "headoffinance",
          name: "Head of Finance",
          data: [
            {
              name: "Top Company Objectives",
              id: 1,
              chunk: [
                {
                  heading: "Overall Company Goals",
                  headingData: [
                    {
                      objective:
                        "Improve annual budgeting and business planning",
                      keyResult: [
                        {
                          id: 18,
                          data: "Identify 100 prospects with high potential",
                          min: "0",
                          max: "100",
                          data_name: "80",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data:
                            "Develop 5-touchpoint process with personalized messages",
                          min: "0",
                          max: "5",
                          data_name: "2",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "List 10 insights on customer journey from interactions with prospects",
                          min: "0",
                          max: "10",
                          data_name: "2",
                          data_type: "",
                        },
                      ],
                    },
                    {
                      objective:
                        "Achieve record revenues while increasing profitability",
                      keyResult: [
                        {
                          id: 18,
                          data: "Hit quarterly revenue of over 1 million",
                          min: "0",
                          max: "1000000",
                          data_name: "800000",
                          data_type: "$",
                        },
                        {
                          id: 19,
                          data: "Start sales in 2 new countries",
                          min: "0",
                          max: "2",
                          data_name: "1",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "Achieve first quarter revenues totaling over 1 million",
                          min: "0",
                          max: "1000000",
                          data_name: "200000",
                          data_type: "$",
                        },
                        {
                          id: 20,
                          data:
                            "Increase gross profit margin from 23% to 54 %s",
                          min: "23",
                          max: "54",
                          data_name: "48",
                          data_type: "%",
                        },
                      ],
                    },
                    {
                      objective: "Increase recurring revenues",
                      keyResult: [
                        {
                          id: 18,
                          data:
                            "Reach monthly recurring revenue (MRR) of $250000",
                          min: "8",
                          max: "250000",
                          data_name: "200000",
                          data_type: "$",
                        },
                        {
                          id: 18,
                          data:
                            "Increase the share of monthly subscriptions vs one-time contracts sold to 85%",
                          min: "0",
                          max: "85",
                          data_name: "65",
                          data_type: "%",
                        },
                        {
                          id: 19,
                          data:
                            "Increase average subscription size to at least 295 $ per month",
                          min: "0",
                          max: "300",
                          data_name: "270",
                          data_type: "$",
                        },
                        {
                          id: 20,
                          data: "Increase annual renewals to 75%",
                          min: "0",
                          max: "75",
                          data_name: "50",
                          data_type: "%",
                        },
                        {
                          id: 20,
                          data: "Reduce churn to less than 1% monthly",
                          min: "0",
                          max: "10",
                          data_name: "2",
                          data_type: "%",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: "financemanager",
          name: "Finance Manager",
          data: [
            {
              name: "Top Company Objectives",
              id: 1,
              chunk: [
                {
                  heading: "Overall Company Goals",
                  headingData: [
                    {
                      objective:
                        "Create the rolling four quarter operating forecast",
                      keyResult: [
                        {
                          id: 18,
                          data: "Finalize bookings outlook with VP Sales",
                          min: "0",
                          max: "1",
                          data_name: "0",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data:
                            "Confirm budgeted hiring with all 23 department heads",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data: "Receive approval on updated model from CEO",
                          min: "0",
                          max: "14",
                          data_name: "23",
                          data_type: "",
                        },
                      ],
                    },
                    {
                      objective:
                        "Ensure financial visibility by helping departments finalize their annual plans",
                      keyResult: [
                        {
                          id: 18,
                          data: "Finalize Marketing’s annual pricing review",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data: "Complete Product’s roadmap prioritization",
                          min: "0",
                          max: "100",
                          data_name: "65",
                          data_type: "%",
                        },
                        {
                          id: 20,
                          data: "Finalize the Customer Success budgeting plan",
                          min: "0",
                          max: "100",
                          data_name: "33",
                          data_type: "%",
                        },
                        {
                          id: 20,
                          data: "Share new dashboard with 23 department heads",
                          min: "0",
                          max: "32",
                          data_name: "20",
                          data_type: "",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: "financeanalyst",
          name: "Finance Analyst",
          data: [
            {
              name: "Top Company Objectives",
              id: 1,
              chunk: [
                {
                  heading: "Overall Company Goals",
                  headingData: [
                    {
                      objective:
                        "Help improve profitability with focus on new product performance by December 21",
                      keyResult: [
                        {
                          id: 18,
                          data:
                            "Gather reports from Accounting on profitability in Q1, Q2, and Q3",
                          min: "0",
                          max: "3",
                          data_name: "3",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data:
                            "Finalize analysis presentation on key drivers of gross margin by November 5",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "Present CFO recommendations for improvements to key operating cycles to drive profitability by December 10",
                          min: "0",
                          max: "1",
                          data_name: "0",
                          data_type: "",
                        },
                      ],
                    },
                    {
                      objective:
                        "Ensure successful launch of product X with precise pricing options",
                      keyResult: [
                        {
                          id: 18,
                          data:
                            "Create report on pricing of top 5 competitors and present to CFO ",
                          min: "0",
                          max: "5",
                          data_name: "3",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data: "Finalize analysis of budgeted cost rollup ",
                          min: "0",
                          max: "100",
                          data_name: "66",
                          data_type: "%",
                        },
                        {
                          id: 20,
                          data: "KPI report shared with Finance Manager",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data: "Receive approval from CEO",
                          min: "0",
                          max: "1",
                          data_name: "0",
                          data_type: "",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: "accountsmanager",
          name: "Accounts Manager",
          data: [
            {
              name: "Top Company Objectives",
              id: 1,
              chunk: [
                {
                  heading: "Overall Company Goals",
                  headingData: [
                    {
                      objective:
                        "Maintain operational health by closing financial statements",
                      keyResult: [
                        {
                          id: 18,
                          data:
                            "Obtain inventory quantity reports from all 30 warehouse managers",
                          min: "0",
                          max: "30",
                          data_name: "14",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data:
                            "Receive balance sheet reconciliations from Accounting",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data: "Approve 12 month-end journal entries",
                          min: "0",
                          max: "12",
                          data_name: "3",
                          data_type: "",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: "marketing",
      name: "Marketing",
      data: [
        {
          id: "marketingmanager",
          name: "Marketing Manager",
          data: [
            {
              name: "Top Company Objectives",
              id: 1,
              chunk: [
                {
                  heading: "Overall Company Goals",
                  headingData: [
                    {
                      objective:
                        "Understand our customers and analyze their behavior",
                      keyResult: [
                        {
                          id: 18,
                          data:
                            "Conduct 12 online client surveys and analyze the results",
                          min: "0",
                          max: "12",
                          data_name: "9",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data:
                            "Map our customer journey to understand what influences their buying decision",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "Map and analyze all of our current marketing channels and give at least 10 recommendations on how to improve them",
                          min: "0",
                          max: "10",
                          data_name: "9",
                          data_type: "",
                        },
                      ],
                    },
                    {
                      objective:
                        "Optimize marketing funnel for more marketing-qualified leads",
                      keyResult: [
                        {
                          id: 18,
                          data: "Develop 3 inbound campaigns",
                          min: "0",
                          max: "3",
                          data_name: "2",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data: "Test 6 lead capture ideas",
                          min: "0",
                          max: "6",
                          data_name: "2",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data: "Grow email signup rates by 50%",
                          min: "0",
                          max: "50",
                          data_name: "24",
                          data_type: "%",
                        },
                      ],
                    },
                    {
                      objective:
                        "Understand our customers and analyze their behavior",
                      keyResult: [
                        {
                          id: 18,
                          data:
                            "Conduct 12 online client surveys and analyze the results",
                          min: "0",
                          max: "12",
                          data_name: "9",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data:
                            "Map our customer journey to understand what influences their buying decision",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "Map and analyze all of our current marketing channels and give at least 10 recommendations on how to improve them",
                          min: "0",
                          max: "10",
                          data_name: "9",
                          data_type: "",
                        },
                      ],
                    },
                    {
                      objective: "Improve outbound marketing performance",
                      keyResult: [
                        {
                          id: 18,
                          data: "50+ qualified leads from webinars",
                          min: "0",
                          max: "50",
                          data_name: "21",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data:
                            "200+ prospects from conferences, exhibitions and networking events",
                          min: "0",
                          max: "250",
                          data_name: "180",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data: "100+ qualified leads from outreach campaign",
                          min: "0",
                          max: "150",
                          data_name: "56",
                          data_type: "",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: "headofmarketing",
          name: "Head of marketing",
          data: [
            {
              name: "Top Company Objectives",
              id: 1,
              chunk: [
                {
                  heading: "Overall Company Goals",
                  headingData: [
                    {
                      objective:
                        "Simplify and clarify our product, messaging, and overall presentation ",
                      keyResult: [
                        {
                          id: 18,
                          data:
                            "25 on-site user-testing sessions to understand key product misunderstandings",
                          min: "0",
                          max: "25",
                          data_name: "9",
                          data_type: "",
                        },
                        {
                          id: 18,
                          data:
                            "Test 10 of our recent infographics and slide decks for customer understanding",
                          min: "0",
                          max: "10",
                          data_name: "3",
                          data_type: "",
                        },
                        {
                          id: 18,
                          data:
                            "Get 1000 answers to an online user survey sent to all last quarter's signups",
                          min: "0",
                          max: "1000",
                          data_name: "863",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data:
                            "Conduct a team hackathon to create and publish full portfolio of product materials",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "Present an action plan for next quarter's messaging improvements",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                      ],
                    },
                    {
                      objective:
                        "Achieve record metrics in all areas of marketing ",
                      keyResult: [
                        {
                          id: 18,
                          data: "170000 website visitors",
                          min: "0",
                          max: "170000",
                          data_name: "120000",
                          data_type: "",
                        },
                        {
                          id: 18,
                          data: "23000 signups",
                          min: "0",
                          max: "23000",
                          data_name: "21000",
                          data_type: "",
                        },
                        {
                          id: 18,
                          data: "7500 trials",
                          min: "0",
                          max: "7500",
                          data_name: "1600",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data: "3500 new paid customers",
                          min: "0",
                          max: "3500",
                          data_name: "500",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data: "Maximum paid user acquisition cost of $25",
                          min: "25",
                          max: "50",
                          data_name: "34",
                          data_type: "$",
                        },
                      ],
                    },
                    {
                      objective: "Improve brand presence",
                      keyResult: [
                        {
                          id: 18,
                          data: "Get 5 earned placements in mainstream media",
                          min: "0",
                          max: "5",
                          data_name: "2",
                          data_type: "",
                        },
                        {
                          id: 18,
                          data:
                            "Collaborate with 3 industry influencers on high-profile campaigns",
                          min: "0",
                          max: "1",
                          data_name: "3",
                          data_type: "",
                        },
                        {
                          id: 18,
                          data: "Boost brand recognition by 50%",
                          min: "0",
                          max: "100",
                          data_name: "40",
                          data_type: "%",
                        },
                        {
                          id: 19,
                          data: "Growing social media following by 100%",
                          min: "45000",
                          max: "100000",
                          data_name: "680000",
                          data_type: "",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: "prodmarketing",
          name: "Product Marketing Manager",
          data: [
            {
              name: "Top Company Objectives",
              id: 1,
              chunk: [
                {
                  heading: "Overall Company Goals",
                  headingData: [
                    {
                      objective:
                        "Keep our customers up to date with product updates",
                      keyResult: [
                        {
                          id: 18,
                          data:
                            "Put together and send out 3 product newsletters to customers",
                          min: "0",
                          max: "3",
                          data_name: "2",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data: "Write 6 blog articles on new product features",
                          min: "0",
                          max: "6",
                          data_name: "3",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data: "Review product help materials once a quarter",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                      ],
                    },
                    {
                      objective: "Gather customer feedback on product changess",
                      keyResult: [
                        {
                          id: 18,
                          data:
                            "Conduct 12 in-depth interviews with existing customers",
                          min: "0",
                          max: "12",
                          data_name: "2",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data: "Listen in to 36 sales calls",
                          min: "0",
                          max: "12",
                          data_name: "36",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "Conduct 3 surveys on customer satisfaction with at least 1000 customers",
                          min: "0",
                          max: "3",
                          data_name: "3",
                          data_type: "",
                        },
                      ],
                    },
                    {
                      objective: "Drive an epic launch for product v3.0",
                      keyResult: [
                        {
                          id: 18,
                          data:
                            "Get 3000 page impressions/downloads within first month of launch",
                          min: "0",
                          max: "3000",
                          data_name: "2800",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data:
                            "Create demo videos for sales that receive 10,000 views",
                          min: "0",
                          max: "10000",
                          data_name: "1200",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "Create 1 customer case study or 3 testimonials supporting the product v3.0 value propositions",
                          min: "0",
                          max: "3",
                          data_name: "2",
                          data_type: "",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: "contentmarketer",
          name: "content Marketer",
          data: [
            {
              name: "Top Company Objectives",
              id: 1,
              chunk: [
                {
                  heading: "Overall Company Goals",
                  headingData: [
                    {
                      objective: "Successfully implement the weekly newsletter",
                      keyResult: [
                        {
                          id: 18,
                          data:
                            "Finalize the content strategy, key messages, and topic structure for the next 6 months",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data:
                            "Grow subscriber base at least 5% per week, getting to 50,000 readers",
                          min: "0",
                          max: "50000",
                          data_name: "24000",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "Increase the CTR% to above industry average 3.5%",
                          min: "0",
                          max: "4",
                          data_name: "2.4",
                          data_type: "%",
                        },
                      ],
                    },
                    {
                      objective: "Improve our content and its distribution",
                      keyResult: [
                        {
                          id: 18,
                          data:
                            "Implement 12 new channels/mediums to post old or new content",
                          min: "0",
                          max: "12",
                          data_name: "9",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data:
                            "Get 60 marketing takeaways from reading 1h of marketing materials a day",
                          min: "0",
                          max: "60",
                          data_name: "24",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data: "Test 1 product review site for paid promotion",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                      ],
                    },
                    {
                      objective: "Activate user-testing of our content",
                      keyResult: [
                        {
                          id: 18,
                          data:
                            "Talk to 10 external editors to receive feedback on our articles and infographics",
                          min: "0",
                          max: "10",
                          data_name: "4",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data:
                            "Conduct 21 face to face content testing and interview sessions with users",
                          min: "0",
                          max: "21",
                          data_name: "12",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "Organize an online survey to rate our various content (min 100 answers)",
                          min: "0",
                          max: "100",
                          data_name: "78",
                          data_type: "",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: "sales",
      name: "Sales",
      data: [
        {
          id: "headofsales",
          name: "Head of Sales",
          data: [
            {
              name: "Top Company Objectives",
              id: 1,
              chunk: [
                {
                  heading: "Overall Company Goals",
                  headingData: [
                    {
                      objective:
                        "Achieve record revenues while increasing profitability",
                      keyResult: [
                        {
                          id: 18,
                          data: "Hit quarterly revenue of $100,000",
                          min: "0",
                          max: "100000",
                          data_name: "23000",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data: "Start sales in 2 new countries ",
                          min: "0",
                          max: "2",
                          data_name: "1",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "Achieve first quarter revenues totaling over $100,000",
                          min: "0",
                          max: "100000",
                          data_name: "34000",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data: "Increase gross profit margin from 23% to 54%",
                          min: "23",
                          max: "55",
                          data_name: "34",
                          data_type: "%",
                        },
                      ],
                    },
                    {
                      objective: "Increase the quality of our sales approach",
                      keyResult: [
                        {
                          id: 18,
                          data:
                            "Make sure at least 50% of signups get a phone call back in first 24 hours",
                          min: "0",
                          max: "50",
                          data_name: "30",
                          data_type: "%",
                        },
                        {
                          id: 19,
                          data:
                            "Have all salespeople listen in to at least 10 product demos of other team members",
                          min: "0",
                          max: "10",
                          data_name: "5",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "Create a best practices sales process document with minimum allowed service levels",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                      ],
                    },
                    {
                      objective: "Optimize our sales process",
                      keyResult: [
                        {
                          id: 18,
                          data:
                            "Hold bi-weekly coaching sessions with every rep",
                          min: "0",
                          max: "100000",
                          data_name: "23000",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data:
                            "Have a new rep present a recording of a sales call and provide round-table feedback every team meeting",
                          min: "0",
                          max: "2",
                          data_name: "1",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "Use survey to understand where rep is struggling, thriving, and how they like to learn",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                      ],
                    },
                    {
                      objective: "Build out the sales team",
                      keyResult: [
                        {
                          id: 18,
                          data: "Hire 6 SDRs",
                          min: "0",
                          max: "6",
                          data_name: "3",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data: "Hire 3 AEs",
                          min: "0",
                          max: "3",
                          data_name: "1",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "Promote 2 AEs this quarter to become Sales Managers or Sales Leads",
                          min: "0",
                          max: "2",
                          data_name: "1",
                          data_type: "",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: "salesmanager",
          name: "Sales Manager",
          data: [
            {
              name: "Top Company Objectives",
              id: 1,
              chunk: [
                {
                  heading: "Overall Company Goals",
                  headingData: [
                    {
                      objective: "Increase recurring revenues",
                      keyResult: [
                        {
                          id: 18,
                          data:
                            "Reach monthly recurring revenue (MRR) of $250,000",
                          min: "0",
                          max: "250000",
                          data_name: "130000",
                          data_type: "$",
                        },
                        {
                          id: 19,
                          data:
                            "Increase the share of monthly subscriptions vs one-time contracts sold to 85%",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "Increase average subscription size to at least $295 per month",
                          min: "0",
                          max: "295",
                          data_name: "230",
                          data_type: "$",
                        },
                        {
                          id: 20,
                          data: "Increase annual renewals to 75%",
                          min: "0",
                          max: "75",
                          data_name: "55",
                          data_type: "%",
                        },
                        {
                          id: 20,
                          data: "Reduce churn to less than 1% monthly",
                          min: "1",
                          max: "10",
                          data_name: "2.5",
                          data_type: "%",
                        },
                      ],
                    },
                    {
                      objective:
                        "Kickstart sales process activity indicator improvements",
                      keyResult: [
                        {
                          id: 18,
                          data:
                            "Increase calls per salesperson to 6300 per quarter",
                          min: "0",
                          max: "6300",
                          data_name: "5400",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data:
                            "Achieve at least 315 demo calls per salesperson per quarter",
                          min: "0",
                          max: "315",
                          data_name: "212",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "Reach at least 33% of online signups via calling them back",
                          min: "0",
                          max: "33",
                          data_name: "12",
                          data_type: "%",
                        },
                        {
                          id: 20,
                          data:
                            "Have each salesperson spend at least 84 hours per month on support chat",
                          min: "0",
                          max: "85",
                          data_name: "76",
                          data_type: "HRS",
                        },
                      ],
                    },
                    {
                      objective:
                        "Have 75% of reps hit over 100% of their quota",
                      keyResult: [
                        {
                          id: 18,
                          data:
                            "8/10 of reps hit or exceed their annual target for the year",
                          min: "0",
                          max: "8",
                          data_name: "7",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data:
                            "Have a minimum of 1 coaching session with every rep each month",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "Run 1 lunch and learn for the team on a new tactic, strategy, or skill every month this year",
                          min: "0",
                          max: "1",
                          data_name: "0",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "Have each salesperson spend at least 84 hours per month on support chat",
                          min: "0",
                          max: "85",
                          data_name: "76",
                          data_type: "HRS",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: "leaddevelopmentexec",
          name: "Lead Development Executive",
          data: [
            {
              name: "Top Company Objectives",
              id: 1,
              chunk: [
                {
                  heading: "Overall Company Goals",
                  headingData: [
                    {
                      objective: "Collect more accurate sales leads data",
                      keyResult: [
                        {
                          id: 18,
                          data:
                            "Create the list of lead metrics and scripted questions to collect in CRM",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data:
                            "Make sure at least 75% of leads have the obligatory question answers filled in",
                          min: "0",
                          max: "75",
                          data_name: "33",
                          data_type: "%",
                        },
                        {
                          id: 20,
                          data:
                            "With development automate the data collection from our backend to CRM",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "Redesign signup form to ask for 3 new obligatory screening questions",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                      ],
                    },
                    {
                      objective:
                        "Build more and better rapport with prospects for sales opportunities",
                      keyResult: [
                        {
                          id: 18,
                          data: "Identify 100 prospects with high potential",
                          min: "0",
                          max: "100",
                          data_name: "78",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data:
                            "Develop 5-touchpoint process with personalized messages",
                          min: "0",
                          max: "5",
                          data_name: "5",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "List 10 insights on customer journey from interactions with prospects",
                          min: "0",
                          max: "10",
                          data_name: "4",
                          data_type: "",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: "hr",
      name: "HR",
      data: [
        {
          id: "headofhr",
          name: "Head of HR",
          data: [
            {
              name: "Top Company Objectives",
              id: 1,
              chunk: [
                {
                  heading: "Overall Company Goals",
                  headingData: [
                    {
                      objective:
                        "Define and promote company culture and values",
                      keyResult: [
                        {
                          id: 18,
                          data:
                            "Survey all employees on our current values (min 75 answers received)",
                          min: "0",
                          max: "100",
                          data_name: "45",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data:
                            "With 3 separate teams, conduct brainstorm sessions to redefine our culture",
                          min: "0",
                          max: "3",
                          data_name: "2",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "Design and promote our new values on intranet and in office environment",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                      ],
                    },
                    {
                      objective:
                        "Define and promote company culture and values",
                      keyResult: [
                        {
                          id: 18,
                          data: "Hire 2 new HR Managers ",
                          min: "0",
                          max: "1",
                          data_name: "2",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data:
                            "Put together hiring guidelines for the Recruitment team",
                          min: "0",
                          max: "100",
                          data_name: "100",
                          data_type: "%",
                        },
                        {
                          id: 20,
                          data: "Organize 3 trainings  for HR employees ",
                          min: "0",
                          max: "3",
                          data_name: "3",
                          data_type: "",
                        },
                      ],
                    },
                    {
                      objective: "Improve employee engagement",
                      keyResult: [
                        {
                          id: 18,
                          data:
                            "Collect monthly engagement surveys with a 75%+ completion rate ",
                          min: "0",
                          max: "75",
                          data_name: "75",
                          data_type: "%",
                        },
                        {
                          id: 19,
                          data:
                            "Analyze engagement data across leadership team",
                          min: "0",
                          max: "100",
                          data_name: "80",
                          data_type: "%",
                        },
                        {
                          id: 20,
                          data:
                            "Communicate engagement data and next steps with organization ",
                          min: "0",
                          max: "100",
                          data_name: "60",
                          data_type: "%",
                        },
                        {
                          id: 20,
                          data:
                            "Begin conducting stay interviews with the team",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                      ],
                    },
                    {
                      objective: "Enhance employer brand",
                      keyResult: [
                        {
                          id: 18,
                          data: "Increase eNPS by 20%",
                          min: "0",
                          max: "20",
                          data_name: "10",
                          data_type: "%",
                        },
                        {
                          id: 19,
                          data: "Grow average employee tenure by 3 months",
                          min: "0",
                          max: "3",
                          data_name: "2",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data: "Share 6 employee stories on social media ",
                          min: "0",
                          max: "6",
                          data_name: "4",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data: "Finalize job description voice and tone guide",
                          min: "0",
                          max: "100",
                          data_name: "90",
                          data_type: "%",
                        },
                        {
                          id: 20,
                          data:
                            "Gain a “Best Places to Work” recognition in a local publication",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: "hrmanager",
          name: "HR Manager",
          data: [
            {
              name: "Top Company Objectives",
              id: 1,
              chunk: [
                {
                  heading: "Overall Company Goals",
                  headingData: [
                    {
                      objective:
                        "Assess training needs to apply and monitor training programs",
                      keyResult: [
                        {
                          id: 18,
                          data:
                            "Review and improve the onboarding plan for new employees",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data:
                            "Gather and analyze feedback from all training activities in the company",
                          min: "0",
                          max: "1",
                          data_name: "0",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "Organise 3 training sessions  for the Management team",
                          min: "0",
                          max: "3",
                          data_name: "2",
                          data_type: "",
                        },
                      ],
                    },
                    {
                      objective:
                        "Improve internal employee job satisfaction score",
                      keyResult: [
                        {
                          id: 18,
                          data: "Launch a new internal career growth portal",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data:
                            "Interview 10 employees on their needs for improving our work culture and benefits",
                          min: "0",
                          max: "10",
                          data_name: "9",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "Develop and present an action plan with 5 improvements for increasing employee satisfaction",
                          min: "0",
                          max: "5",
                          data_name: "2",
                          data_type: "",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: "recruitmentmanager",
          name: "Recruitment Manager",
          data: [
            {
              name: "Top Company Objectives",
              id: 1,
              chunk: [
                {
                  heading: "Overall Company Goals",
                  headingData: [
                    {
                      objective:
                        "Recruitment outreach campaign for engineering",
                      keyResult: [
                        {
                          id: 18,
                          data: "Conduct career day seminars in 5 universities",
                          min: "0",
                          max: "5",
                          data_name: "1",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data:
                            "Harvest Linkedin to collect 250 potential new candidates",
                          min: "0",
                          max: "250",
                          data_name: "200",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "Organise an open career day at the office with at least 50 participants",
                          min: "0",
                          max: "50",
                          data_name: "25",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "Redesign and publish our careers and jobs website section",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                      ],
                    },
                    {
                      objective:
                        "Be up to date with competitors hiring practices. ",
                      keyResult: [
                        {
                          id: 18,
                          data:
                            "Review competitor´s hiring campaigns and gather insights 3  times  (once per month)",
                          min: "0",
                          max: "3",
                          data_name: "1",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data:
                            "Put together a strategy that shows our advantages over competitors.",
                          min: "0",
                          max: "10",
                          data_name: "4",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "Survey potential hires of our advantages/disadvantages compared to competitors.",
                          min: "0",
                          max: "1",
                          data_name: "3",
                          data_type: "",
                        },
                      ],
                    },
                    {
                      objective:
                        "Develop a sustainable candidate lead strategy",
                      keyResult: [
                        {
                          id: 18,
                          data:
                            "Partner with 3 platforms  to regularly share job ads",
                          min: "0",
                          max: "4",
                          data_name: "2",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data:
                            "Partner with 4 yearly hiring events  where to showcase our company",
                          min: "0",
                          max: "4",
                          data_name: "2",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "Build a database of rejected candidates who might be useful in the future",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: "admin",
      name: "Admin",
      data: [
        {
          id: "overalladminokr",
          name: "Overall Admin OKRs",
          data: [
            {
              name: "Top Company Objectives",
              id: 1,
              chunk: [
                {
                  heading: "Overall Company Goals",
                  headingData: [
                    {
                      objective: "Improve internal document management",
                      keyResult: [
                        {
                          id: 18,
                          data:
                            "Choose and launch new document sharing platform",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data:
                            "Have each of 17 teams create their own directory structure for documents",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "Move 75% of existing % of documents from file servers to new system",
                          min: "0",
                          max: "17",
                          data_name: "13",
                          data_type: "",
                        },
                      ],
                    },
                    {
                      objective:
                        "Improve satisfaction with receptionist's work",
                      keyResult: [
                        {
                          id: 18,
                          data:
                            "Decrease number of complaints and negative feedback per quarter from 15 to 5",
                          min: "0",
                          max: "75",
                          data_name: "50",
                          data_type: "%",
                        },
                        {
                          id: 19,
                          data:
                            "Increase positive feedback items and praise from 5 to 15 per quarter",
                          min: "5",
                          max: "15",
                          data_name: "12",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "Increase end-user satisfaction rating from 4.0 to 5",
                          min: "4",
                          max: "5",
                          data_name: "4.1",
                          data_type: "%",
                        },
                      ],
                    },
                    {
                      objective:
                        "Improve our document and information management procedures",
                      keyResult: [
                        {
                          id: 18,
                          data:
                            "Implement a better system for tracking incoming requests",
                          min: "0",
                          max: "1",
                          data_name: "0",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data:
                            "Review software options for incoming document tracking",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "Start compiling a weekly 'office highlights' newsletter to all team memebers",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                      ],
                    },
                    {
                      objective:
                        "Self-educate in areas related to being a great secretary",
                      keyResult: [
                        {
                          id: 18,
                          data:
                            "Take 2 online video courses on being a great secretary",
                          min: "0",
                          max: "2",
                          data_name: "1",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data:
                            "Read daily on topics related to customer success in front office",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "Conduct a survey among colleagues to evaluate areas of improvement in my work",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: "design",
      name: "Design",
      data: [
        {
          id: "ui",
          name: "UI",
          data: [
            {
              name: "Top Company Objectives",
              id: 1,
              chunk: [
                {
                  heading: "Overall Company Goals",
                  headingData: [
                    {
                      objective: "Redesign and launch our new landing page",
                      keyResult: [
                        {
                          id: 18,
                          data:
                            "Test existing landing page and sub-pages on external users for understanding issues",
                          min: "0",
                          max: "1",
                          data_name: "0",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data:
                            "Conduct stakeholder interviews with 10 people from sales and marketing",
                          min: "0",
                          max: "10",
                          data_name: "3",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "Design new version of our site structure, navigation and all pages",
                          min: "0",
                          max: "100",
                          data_name: "78",
                          data_type: "%",
                        },
                        {
                          id: 20,
                          data: "User-test page prototypes on 12 people",
                          min: "0",
                          max: "12",
                          data_name: "3",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "With development and marketing, launch by November 1st",
                          min: "0",
                          max: "1",
                          data_name: "0",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "Increase visitor to % sign-up ratio from 9% to 15%",
                          min: "9",
                          max: "15",
                          data_name: "13",
                          data_type: "%",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          id: "graphicdesign",
          name: "Graphic Design",
          data: [
            {
              name: "Top Company Objectives",
              id: 1,
              chunk: [
                {
                  heading: "Overall Company Goals",
                  headingData: [
                    {
                      objective:
                        "Support marketing and sales with design deliverables",
                      keyResult: [
                        {
                          id: 18,
                          data: "12 infographic and slide sets",
                          min: "0",
                          max: "12",
                          data_name: "10",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data: "1 special campaign marketing minisite",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data: "10 product & support PDF documents",
                          min: "0",
                          max: "10",
                          data_name: "8",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data: "2 PDF e-books, white papers or case studies ",
                          min: "0",
                          max: "2",
                          data_name: "1",
                          data_type: "",
                        },
                      ],
                    },
                    {
                      objective:
                        "Organize, simplify, and standardize our external design resources",
                      keyResult: [
                        {
                          id: 18,
                          data: "Put together and publish our style guide",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data: "Update our sales materials to common format",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data: "Update our website to follow our design guide",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                      ],
                    },
                    {
                      objective:
                        "Test infographics and marketing materials on real users",
                      keyResult: [
                        {
                          id: 18,
                          data:
                            "Analyze the efficiency of the designs ourselves",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data:
                            "Test the designs on external target group people and find their subjective opinions",
                          min: "0",
                          max: "1",
                          data_name: "1",
                          data_type: "%",
                        },
                        {
                          id: 20,
                          data:
                            "Nominate our designs for 3 design competition. ",
                          min: "0",
                          max: "3",
                          data_name: "2",
                          data_type: "%",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: "customersupport",
      name: "Customer Support",
      data: [
        {
          id: "customersupportokr",
          name: "Customer Support OKRs",
          data: [
            {
              name: "Top Company Objectives",
              id: 1,
              chunk: [
                {
                  heading: "Overall Company Goals",
                  headingData: [
                    {
                      objective: "Research and improve customer satisfaction",
                      keyResult: [
                        {
                          id: 18,
                          data: "Exceed Net Promoter Score (NPS) of over 8.0",
                          min: "0",
                          max: "10",
                          data_name: "6",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data:
                            "Get 1000 survey responses to annual satisfaction survey",
                          min: "0",
                          max: "1000",
                          data_name: "450",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "Conduct 50 phone interviews with top customers",
                          min: "0",
                          max: "50",
                          data_name: "32",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "Conduct 15 phone interviews with recently churned customers",
                          min: "0",
                          max: "10",
                          data_name: "2",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "Present an action plan of 10 improvements for next quarter",
                          min: "0",
                          max: "10",
                          data_name: "9",
                          data_type: "",
                        },
                      ],
                    },
                    {
                      objective:
                        "Improve satisfaction with support team's work",
                      keyResult: [
                        {
                          id: 18,
                          data:
                            "Decrease number of complaints and negative feedback per quarter from 15 to 5",
                          min: "5",
                          max: "15",
                          data_name: "10",
                          data_type: "",
                        },
                        {
                          id: 19,
                          data:
                            "Increase positive feedback items and praise from 5 to 15 per quarter",
                          min: "5",
                          max: "15",
                          data_name: "12",
                          data_type: "",
                        },
                        {
                          id: 20,
                          data:
                            "Increase end-user satisfaction rating from 4.0 to 4.5",
                          min: "4",
                          max: "4.5",
                          data_name: "4.1",
                          data_type: "",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
export default data;
